import { AbortTripButton } from '../components/AbortTripButton';
import { canOfferAbort } from '../policies/abort-visibility.policy';

interface AbortTripActionProps {
  tripId: string;
  tripStatus: string;
  canDispatch: boolean;
  onAborted: () => void;
}

/** The Abort trip button and its form, for the trip page: nothing when the user may not abort or the trip is past the point it can be. */
export function AbortTripAction({ tripId, tripStatus, canDispatch, onAborted }: AbortTripActionProps) {
  if (!canOfferAbort(tripStatus, canDispatch)) return null;
  return <AbortTripButton tripId={tripId} onAborted={onAborted} />;
}
